import { IEnvironment, defaultEnvironment } from "./environment.default";

export const environment: IEnvironment = {
  ...defaultEnvironment,
  production: false,
  name: 'DEV',
  enabledLoggerService: true,
  apiBaseUrl: '/api/v1'
}
